import { MissingRequiredParameterError } from './errors';
import { commonIntegrationDataToQuery, integrationDataFromQuery } from './integration-data';
export function checkoutDataFromQuery(query) {
  const planId = query.get('planId') ?? undefined;
  const planSlug = query.get('planSlug') ?? undefined;
  const checkoutFlowId = query.get('checkoutFlowId') ?? undefined;
  const pricingVariantId = query.get('pricingVariantId') ?? undefined;
  const _integrationDataFromQ = integrationDataFromQuery(query),
    navigateTo = _integrationDataFromQ.navigateTo,
    navigateToPageProps = _integrationDataFromQ.navigateToPageProps,
    navigateToSectionProps = _integrationDataFromQ.navigateToSectionProps,
    maxStartDate = _integrationDataFromQ.maxStartDate,
    minStartDate = _integrationDataFromQ.minStartDate,
    biOptions = _integrationDataFromQ.biOptions,
    verticalStatusContent = _integrationDataFromQ.verticalStatusContent;
  const base = {
    navigateTo,
    navigateToPageProps,
    navigateToSectionProps,
    minStartDate,
    maxStartDate,
    biOptions,
    verticalStatusContent,
    memberId: query.get('memberId') ?? undefined,
    orderId: query.get('orderId') ?? undefined,
    pricingVariantId
  };
  if (planId) {
    return {
      ...base,
      planId,
      checkoutFlowId,
      planSlug: undefined
    };
  } else if (planSlug) {
    return {
      ...base,
      planId: undefined,
      checkoutFlowId,
      planSlug
    };
  } else {
    throw new MissingRequiredParameterError('planId', 'planSlug');
  }
}
export function checkoutDataToQuery(data) {
  const query = commonIntegrationDataToQuery(data.integrationData);
  query.set('planId', data.planId);
  data.memberId && query.set('memberId', data.memberId);
  data.orderId && query.set('orderId', data.orderId);
  data.checkoutFlowId && query.set('checkoutFlowId', data.checkoutFlowId);
  data.pricingVariantId && query.set('pricingVariantId', data.pricingVariantId);
  return query;
}
//# sourceMappingURL=checkout-data.js.map